module.exports = __webpack_public_path__ + "assets/bg-pc-en-27413bc5.png";